import React from 'react'
import {Link} from 'react-router-dom'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import GameProducer from '../components/GameProducer'

import headerLoginImage from '../assets/imgs/slider.jpg'
import language from '../assets/language';
import games from '../assets/social-games';

import topGameImg from '../assets/imgs/Asset1.png'
import bottomGameImg from '../assets/imgs/Asset2.png'
import headerRegisterImage from '../assets/imgs/home-image.png'
import {Helmet} from "react-helmet";
import {Faq} from '../components/Faq';

const gameProducersRowOne = [
    {
        image: require('../assets/imgs/oryxgaming.png')
    },
    {
        image: require('../assets/imgs/booming.png')
    },
    {
        image: require('../assets/imgs/amatic.png')
    },
    {
        image: require('../assets/imgs/redrake.png')
    },
    {
        image: require('../assets/imgs/givme.png')
    },
    {
        image: require('../assets/imgs/playngo.png')
    }
]
const gameProducersRowTwo = [
    {
        image: require('../assets/imgs/evolution.png'),
    },
    {
        image: require('../assets/imgs/gamomat.png'),
    },
    {
        image: require('../assets/imgs/goldenhero.png'),
        classCustom: 'w-50'
    },
    {
        image: require('../assets/imgs/pragmaticplay.png'),
    },
    {
        image: require('../assets/imgs/netent.png'),
    },
    {
        image: require('../assets/imgs/kalamba.png'),
    }
]
const gameProducersRowThree = [
    {
        image: require('../assets/imgs/microgaming.png')
    },
    {
        image: require('../assets/imgs/stake.png')
    }
]

class Homepage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            gameList: [],
            errorMessage: "",
            limit: 12,
            showLoadMoreButton: true,
            numberOfGames: 0
        }

        this.loadMore = this.loadMore.bind(this);
    }

    state = {
        showReadMore: false
    }

    toggle = () => this.setState((currentState) => ({showReadMore: !currentState.showReadMore}));

    componentDidMount() {
        this.setState({
            gameList: games,
        });
    }

    loadMore = (e) => {
        e.preventDefault();

        if (this.state.limit + 25 >= this.state.gameList.length) {
            this.setState({showLoadMoreButton: false})
        }

        this.setState({limit: this.state.limit + 25})
    }

    //helpere
    showFeaturedGames = (playAllGames, numberOfGames = 'all') => {
        return this.state.gameList.slice(0, this.state.limit).map((game, index) => {

            if(numberOfGames != 'all'){
                if(index >= numberOfGames){
                    return;
                }
            }


            let link;
            let gameBlur = '';

            if (playAllGames !== true) {
                if (game.canPlay === true) {
                    link = <Link to={`/game/` + game.id} className="btn-custom primary-color border-0 bg-yellow">{language.buttons.play}</Link>
                } else {
                    if (localStorage['isReturnVisitor']) {
                        link = <div className='div-homepage-register'><a className='button-login'
                                                                         onClick={this.props.showLoginModal}>{language.buttons.login_and_play}</a>
                        </div>
                    } else {
                        link = <div className='div-homepage-register'><a className='button-login'
                                                                         onClick={this.props.showModal}>新規登録してプレイ</a>
                        </div>
                    }

                    gameBlur = 'game-blur'
                }
            } else {
                link = <Link to={`/game/` + game.id} className="btn-custom primary-color border-0 bg-yellow">{language.buttons.play}</Link>
            }


            return (
                <div key={index} className='col-lg-3 col-md-6 col-sm-6 col-12'>
                    {(playAllGames !== false || game.canPlay === true) ?
                        <div>
                            <div className='game-img'>
                                <img src={"https:" + game.thumbnailUrl} alt=''/>
                            </div>
                            <div className='game-play'>
                                <h3>{game.name}</h3>
                                {link}
                            </div>
                        </div>
                        :
                        <div>
                            <div className='game-img'>
                                <img className={gameBlur} src={"https:" + game.thumbnailUrl} alt=''/>
                            </div>
                            <div className='game-play'>
                                <h3>{game.name}</h3>
                                {link}
                            </div>
                        </div>
                    }
                </div>

            )
        })
    }


    showGames = (playAllGames) => {
        return this.state.gameList.slice(0, this.state.limit).map((game, index) => {

            let link;
            let gameBlur = '';

            if (playAllGames !== true) {
                if (game.canPlay === true) {
                    link = <Link to={`/game/` + game.id} className="btn-custom primary-color border-0 bg-yellow">{language.buttons.play}</Link>
                } else {
                    if (localStorage['isReturnVisitor']) {
                        link = <div className='div-homepage-register'><a className='button-login'
                                                                         onClick={this.props.showLoginModal}>{language.buttons.login_and_play}</a>
                        </div>
                    } else {
                        link = <div className='div-homepage-register'><a className='button-login'
                                                                         onClick={this.props.showModal}>{language.buttons.register}</a>
                        </div>
                    }

                    gameBlur = 'game-blur'
                }
            } else {
                link = <Link to={`/game/` + game.id} className="btn-custom primary-color border-0 bg-yellow">{language.buttons.play}</Link>
            }


            return (
                <div key={index} className='col-lg-3 col-md-6 col-sm-6 col-12 mb-4'>
                    {(playAllGames !== false || game.canPlay === true) ?
                        <div>
                            <div className='game-img-hover'>
                                <img src={"https:" + game.thumbnailUrl} alt=''/>
                                <div className='game-play-hover'>
                                    <h3>{game.name}</h3>
                                    {link}
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className='game-img-hover'>
                                <img className={gameBlur} src={"https:" + game.thumbnailUrl} alt=''/>
                                <div className='game-play-hover'>
                                    <h3>{game.name}</h3>
                                    {link}
                                </div>
                            </div>
                        </div>
                    }
                </div>

            )
        })
    }

    showGameProducers = (row) => {
        window.getSelection().empty()
        return row.map((elem, index) => (
            <GameProducer
                key={index}
                image={elem.image}
            />
        ))
    }

    render() {
        let playAllGames = true;
        let headerImage = headerRegisterImage;
        let CtaHeader =   <div className="text-banner">
            <h1>{language.homepage.cta}</h1>
            <a className="button-register" onClick={this.props.showModal}>{language.buttons.login}</a>
        </div>
        let showMoreContent = <div className="text-center">
            <a href='#' onClick={this.loadMore} className='button-login show-content-btn'>
                {language.buttons.show_more}
            </a>
        </div>;

        if (this.props.currentUser) {
            playAllGames = true;

        }


        if (!this.state.showLoadMoreButton) {
            showMoreContent = "";
        }

        // if (localStorage['isReturnVisitor']) {
        headerImage = headerLoginImage;
        CtaHeader =
            <div className="text-banner">
                <h1>{language.homepage.cta}</h1>
                <a className="button-register" href='#all-games'>{language.buttons.play}</a>
            </div>
        // }

        return (
            <div className='section-home'>
                <div className='homepage__container'>
                    <Helmet>
                        <title>Casino Spiele Kostenlos Ohne Anmeldung Spielen - Hyperino</title>
                        <meta name={"description"} content={"Spielen Sie kostenlos casino spiele ohne Einzahlung oder Anmeldung. Hier können Sie die tollsten Spielautomaten kostenlos spielen, wann immer Sie wollen @hyperino"} />
                        <link rel="canonical" href={"https://hyperino.social/"} />
                    </Helmet>

                    {!this.props.currentUser &&
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='slideshow__container'  style={{backgroundImage: `url(${headerImage})`}}>
                                    {CtaHeader}
                                </div>
                            </div>
                        </div>
                    }
                    <div className='row'>
                        <div className="col-md-12">
                            <div className="layout">
                                <h2 className="color-white">{language.homepage.recommended_free_games}</h2>
                            </div>
                        </div>
                        {this.showFeaturedGames(playAllGames , 4)}
                    </div>
                </div>

                <div className="img-home">
                    <img className="w-100" src={topGameImg}/>
                </div>
                <div className='bg-yellow'>
                    <div className='game-container' id='all-games'>
                        <div className='row'>
                            <div className="col-md-12">
                                <div className="layout">
                                    <h2 className="color-black1">{language.homepage.all_free_games}</h2>
                                </div>
                            </div>
                            {this.showGames(playAllGames)}
                        </div>
                        {showMoreContent}

                        <div className="row mt-75">
                            <div className="col-md-12 col-lg-9 m-auto text-center">
                                <p>
                                    Wir alle kennen das Gefühl, wenn es Sie in den Fingern juckt, Ihr Lieblingsspiel im Casino zu spielen, Sie sich aber nicht die Mühe machen wollen, sich zu registrieren. Oder vielleicht sind Sie auch nur auf der Suche nach einem neuen Ort zum Ausprobieren und möchten sich noch nicht festlegen. Was auch immer Ihre Gründe sind, die Suche nach <a href="https://hyperino.social/"> casino spiele kostenlos </a> ohne anmeldung kann schwierig sein. Zum Glück haben wir eine Lösung für Sie. In diesem ultimativen Leitfaden zeigen wir Ihnen, wo Sie die besten casino spiele kostenlos spielen finden, ohne dass Sie ein Konto erstellen und eine Einzahlung tätigen müssen. Außerdem geben wir Ihnen einige Tipps, wie Sie das Beste aus Ihrem Erlebnis machen können. Also, ohne weitere Umschweife, fangen wir an!
                                </p>
                                <h2>Worauf sollten Sie bei casino spiele kostenlos ohne anmeldung achten?</h2>
                                <p className={` ${this.state.showReadMore ? '' : 'mask-text'}`}>
                                    Wenn Sie auf der Suche nach casino spiele kostenlos ohne anmeldung sind, sollten Sie einige Dinge im Auge behalten. In erster Linie sollten Sie sich vergewissern, dass die Website seriös und vertrauenswürdig ist. Es gibt viele Betrüger, deshalb ist es wichtig, dass Sie sich informieren. Aber bei Hyperino casino können Sie sicher sein, dass wir uns sehr um Ihre Sicherheit kümmern und Ihnen die bestmögliche Erfahrung bieten. Die zweite Sache, auf die Sie achten sollten, ist eine gute Auswahl an Spielen. Sie möchten sich nicht auf eine Handvoll von Optionen beschränken. Auch hier haben wir für Sie vorgesorgt, denn auf unserer Website finden Sie eine große Auswahl der beliebtesten und bekanntesten Spielautomaten. Und das alles in der Demoversion, absolut risikofrei! Und zu guter Letzt sollten Sie darauf achten, dass die Seite, auf der Sie spielen, faire Bedingungen bietet. Natürlich können Sie sich die Bedingungen auf unserer Hyperino casino Website genau ansehen. Mit diesen Kriterien im Hinterkopf können Sie sicher sein, das beste casino spiele kostenlos spielen zu finden!
                                </p>
                                <button type={'button'} className={`btn-custom color-white border-0 show-content-btn ${this.state.showReadMore ? 'hidden' : ''}`} onClick={this.toggle}>Read More</button>

                                {this.state.showReadMore &&
                                    <>
                                        <h2>Die Vorteile von Casino-Spielen zum Spaß</h2>
                                        <p>
                                            Das Beste am Spielen von casino spiele kostenlos ohne anmeldung bei Hyperino casino ist, dass Sie es zum Spaß tun können. Sie stehen nicht unter dem Druck, gewinnen zu müssen oder Wettanforderungen zu erfüllen. Sie können sich einfach zurücklehnen, entspannen und das Erlebnis genießen. Das Spielen zum Spaß gibt Ihnen auch die Möglichkeit, neue Spiele und Strategien auszuprobieren. Vielleicht wollten Sie schon immer einmal das neue Spielautomaten-Spiel ausprobieren, das gerade auf den Markt gekommen ist, oder das Spiel, über das jeder zu reden scheint, hatten aber nie das Geld dafür. Oder vielleicht möchten Sie eine neue Wettstrategie ausprobieren, bevor Sie sie mit echtem Geld einsetzen. Was auch immer der Fall sein mag, das Spielen zum Spaß ist eine großartige Möglichkeit, dies zu tun. So haben Sie die Möglichkeit, sich mit dem Spielablauf vertraut zu machen und die Regeln in- und auswendig zu lernen. Außerdem können Sie so viele Spiele ausprobieren und testen, bis Sie eines oder mehrere gefunden haben, die genau Ihrem Geschmack und Ihren Bedürfnissen entsprechen.
                                        </p>
                                        <h2>Wie Sie das Beste aus Ihrer casino spiele kostenlos ohne anmeldung Erfahrung machen</h2>
                                        <p>
                                            Jetzt, wo Sie wissen, wo und wie Sie casino spiele kostenlos ohne anmeldung finden, ist es an der Zeit zu lernen, wie Sie das Beste aus Ihren Erfahrungen machen können. Hier sind ein paar Tipps, die Ihnen den Einstieg erleichtern: - Lesen Sie die Allgemeinen Geschäftsbedingungen: Das mag selbstverständlich klingen, aber es ist wichtig, dass Sie das Kleingedruckte lesen, bevor Sie ein Spiel spielen. Auf diese Weise wissen Sie genau, worauf Sie sich einlassen, und werden nicht durch irgendetwas überrumpelt. - Seien Sie vorsichtig mit persönlichen Informationen: Wenn Sie casino spiele kostenlos ohne anmeldung spielen, werden Sie möglicherweise aufgefordert, einige persönliche Daten anzugeben. Seien Sie vorsichtig mit den Informationen, die Sie weitergeben, und geben Sie nur Informationen preis, mit denen Sie einverstanden sind. - Halten Sie sich an seriöse Websites: Wie wir bereits erwähnt haben, gibt es jede Menge Betrug da draußen. Wenn Sie also mit Hyperino casino spielen, müssen Sie sich nicht mehr fragen, ob die Seite, die Sie gefunden haben, seriös ist oder ob es sich um einen Betrug handelt, der Ihre Daten nicht sicher speichert. Bei Hyperino casino verwenden wir die neueste SSL-Verschlüsselungstechnologie, um sicherzustellen, dass Ihre persönlichen Daten immer sicher sind und Sie Ihr Glücksspielerlebnis unbesorgt genießen können. - Haben Sie Spaß: Dies ist der wichtigste Tipp von allen! Casinospiele sollten Spaß machen, also sorgen Sie dafür, dass Sie Spaß dabei haben. Wenn Sie das nicht haben, ist es Ihre Zeit wahrscheinlich nicht wert. Wenn Sie diese Tipps befolgen, werden Sie mit Sicherheit eine tolle Zeit beim casino spiele kostenlos spielen haben!
                                        </p>
                                        <h2>Die 5 besten Slots-Casinospiele zum kostenlosen Spielen</h2>
                                        <p>
                                            Bei Hyperino casino bieten wir unseren Spielern eine große Auswahl an Spielen, aber jetzt möchten wir Ihnen eine Liste unserer Lieblings-Spielautomaten geben, die Sie in der Demoversion genießen können, nur zum Spaß und zum Spielen! 1. <a href='https://hyperino.social/game/book-of-dead'>Book of Dead Demo</a>: Book of Dead ist ein Pionier, sowohl was das Konzept als auch die Ausführung betrifft. Es ist möglich, dass es den Test der Zeit überstanden hat und deshalb auch heute noch eine beliebte Play'n GO-Option ist. Möglicherweise liegt das daran, dass dieser Entwickler Bilder und eingebaute Elemente verwendet, um das Thema wirklich zum Leben zu erwecken. Wie dem auch sei, Book of Dead ist einer dieser Spielautomaten, den jeder zumindest einmal spielen sollte. 2. <a href='https://hyperino.social/game/legacy-of-dead-playngo'>Legacy of Dead Demo</a>: Play n' Go hat jetzt einen neuen Spielautomaten in seiner Legacy/Book/Dead-Serie eingeführt. Eine Rezension mag an dieser Stelle fast überflüssig erscheinen, denn wenn man einen gespielt hat, hat man sie so ziemlich alle gespielt. Wie dem auch sei, es ist an der Zeit, sich mit Sonnencreme mit Faktor 50 einzucremen und ins alte Ägypten zurückzukehren. Ist die Zeit gut investiert? Interessierte Archäologen können ihre gut abgenutzte brennende Fackel mitbringen und sich uns anschließen, um es herauszufinden. 3. Marmeladengläser: <a href='https://hyperino.social/game/push-jammin-jars'>Jammin Jars Demo</a> bringt Sie in Stimmung! Jeder wippt mit den Füßen im Takt, wenn Jam Jars mit jedem Sieg über die Tanzfläche tanzt und durch den wachsenden Multiplikator noch mehr Gewinne erzielt. Das Rainbow Feature verstreut riesige Fruchtsymbole auf der Tanzfläche, bevor sie in riesige Gewinne explodieren. Die Funky Free Games beginnen, wenn drei Jam Jars die Tanzfläche berühren! Beobachten Sie, wie die Marmeladengläser tanzen und die Multiplikatoren möglicherweise ins Unendliche wachsen! 4. Das Hundehaus: Wir loben Pragmatic Play nur selten für ihre grafische Arbeit, und diese hier ist sicherlich nicht besonders clever. Nichtsdestotrotz ist es schwierig, sich nicht von dem hellen und fröhlichen Design im Cartoon-Stil und den übergroßen Symbolen, die sich dreist weigern, in den Rahmen zu passen, in den Bann ziehen zu lassen. Die Hintergrundmusik im Walzer-Stil ist sicherlich hilfreich. 5. <a href='https://hyperino.social/game/razorshark_push'>Razor Shark</a>: In der neuesten Version von Push Gaming schwimmen Sie mit Haien, was angesichts der bösartigen Natur des Spiels eine passende Metapher ist. Das Spielkonzept ist ziemlich ähnlich, aber die Volatilität wurde auf etwa 11 erhöht, und das Potenzial ist deutlich höher als bei allen anderen Push Gaming-Slots bisher. Dies sind nur einige der besten Slots-Spiele, die Sie kostenlos spielen können. Also, worauf warten Sie noch? Beginnen Sie noch heute zu spielen! Hyperino casino bietet eine große Auswahl an casino spiele kostenlos ohne anmeldung, die Sie absolut risikofrei und nur zum Spaß spielen können. Sie brauchen sich nicht zu registrieren oder eine Software herunterzuladen, wählen Sie einfach Ihr Spiel und beginnen Sie zu spielen.
                                        </p>
                                        <h2>Abschließender Gedanke</h2>
                                        <p>
                                            Kostenlose Casinospiele sind eine großartige Möglichkeit, um mit dem Online-Glücksspiel zu beginnen. Sie ermöglichen es Ihnen, neue Spiele auszuprobieren und Ihre Fähigkeiten zu testen, ohne Geld zu riskieren. Und sobald Sie sich wohl fühlen, können Sie um echtes Geld spielen. Also, worauf warten Sie noch? Beginnen Sie noch heute zu spielen! Hyperino casino ist der beste Ort, um mit dem Spielen von casino spiele kostenlos spielen zu beginnen!
                                        </p>
                                        <button type={'button'} className={this.state.showReadMore ? 'btn-custom color-white border-0 show-content-btn' : 'hidden'} onClick={this.toggle}>Close</button>
                                    </>
                                }
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-8 m-auto">
                                <Faq />
                            </div>
                        </div>

                        <div className="row mt-75">
                            <div className="col-md-12 col-lg-9 m-auto">
                                <h4 className="title-providers">{language.homepage.games_providers}</h4>
                                <div className="row mt-5 mb-75">
                                    {this.showGameProducers(gameProducersRowOne)}
                                </div>
                                <div className="row mb-75">
                                    {this.showGameProducers(gameProducersRowTwo)}
                                </div>
                                <div className="row justify-content-center">
                                    {this.showGameProducers(gameProducersRowThree)}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="img-home">
                    <img className="w-100" src={bottomGameImg}/>
                </div>

            </div>
        )
    }
}

export default Homepage
